/**
 * useOrganization Hook
 * 
 * Hook for accessing the current organization context.
 * Wraps useAuthStore to provide a simpler API for components.
 */

import { useAuthStore } from '../store/auth';

interface UseOrganizationReturn {
  currentOrganization: {
    id: string;
    name: string;
    role: string;
  } | null;
}

export function useOrganization(): UseOrganizationReturn {
  const { activeOrg } = useAuthStore();
  
  return {
    currentOrganization: activeOrg,
  };
}
